/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Export_To_PortalsInputs */

const cs_form_export_to_portals = /** @type {(inputs: Form_Export_To_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportovat na portály`)
};

const en_form_export_to_portals = /** @type {(inputs: Form_Export_To_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export to portals`)
};

/**
* | output |
* | --- |
* | "Export to portals" |
*
* @param {Form_Export_To_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_export_to_portals = /** @type {((inputs?: Form_Export_To_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Export_To_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_export_to_portals(inputs)
	return cs_form_export_to_portals(inputs)
});